<div class="flex flex-middle pos-relative">
    @for (option of options; track $index; let isFirst = $first) {
    <button class="flex flex-middle"
            [ngClass]="[isSelected(option) ? 'col-43' : 'col-42', isFirst ? 'm-r-2 m-r-3-s' : '']"
            role="button"
            [attr.aria-label]="'Switch to % columns' | translate : option.size"
            (click)="setState(option.size)">
        <i class="inline-flex"
           [ngClass]="'icon-grid-' + option.size"
           [style.font-size.px]="24"
           aria-hidden="true"></i>
    </button>
    }
</div>